module.exports = __webpack_public_path__ + "img/slow_moving_products.75c7dd9d.svg";